import { Component } from 'vue';
import { RouteConfig } from 'vue-router';
import { RoutePropsFunction } from 'vue-router/types/router';
import _ from 'lodash';

import Login from '@/user/pages/login/Login.vue';
import Unauthorized from '@/user/pages/unauthorized/Unauthorized.vue';
import Exception from '@/user/pages/exception/Exception.vue';

import Authorized from '@/user/pages/authorized/Authorized.vue';
import CourseSelect from '@/user/pages/authorized/courseSelect/CourseSelect.vue';
import UnitSelect from '@/user/pages/authorized/unitSelect/UnitSelect.vue';
import StampSelect from '@/user/pages/authorized/stampSelect/StampSelect.vue';
import Study from '@/user/pages/authorized/study/Study.vue';

import { USER_STORAGE_KEY } from '@/classes/common/Constants';
import StorageUtility from '@/classes/common/StorageUtility';




/** ルート型定義 */
export interface RouteData {
  path: string
  name: string
  component?: Component
  props?: boolean | Object | RoutePropsFunction,
  redirect?: Function
}

/** 公開ルート型定義 */
interface PublicRoutesData {
  [key: string]: RouteData // index signature
  /** ログイン */
  Login: RouteData
  /** 認証エラー */
  Unauthorized: RouteData
  /** エラー */
  Exception: RouteData
  /** URLエラー */
  NotFound: RouteData
}

/** 認証後ルート型定義 */
interface AuthorizedRoutesData {
  [key: string]: RouteData // index signature
  /** 科目選択 */
  CourseSelect: RouteData
  /** スタンプ選択 */
  StampSelect: RouteData
  /** ユニット選択 */
  UnitSelect: RouteData
  /** 学習画面 */
  Study: RouteData
};

/** 学習機能ルート型定義 */
export type RoutesType = PublicRoutesData & AuthorizedRoutesData;

/** 学習機能公開ルート定数 */
export const PublicRoutes: PublicRoutesData = {
  LoginRedirect: {
    path: '/user',
    name: 'LoginRedirect',
    redirect: () => {
      const roomId = StorageUtility.getLocalData<string>(USER_STORAGE_KEY.ROOM_ID);
      return roomId !== null ? `/user/login/${roomId}` : 'NotFound';
    },
  },
  Login: {
    path: '/user/login/:roomId',
    name: 'Login',
    component: Login,
  },
  Unauthorized: {
    path: '/user/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
  },
  Exception: {
    path: '/user/exception',
    name: 'Exception',
    component: Exception,
  },
  NotFound: {
    path: '*',
    name: 'NotFound',
    component: Exception,
  }
};

/** 学習機能認証後ルート定数 */
export const AuthorizedRoutes: AuthorizedRoutesData = {
  CourseSelect: {
    path: '/user/courseSelect',
    name: 'CourseSelect',
    component: CourseSelect,
  },
  StampSelect: {
    path: '/user/stampSelect',
    name: 'StampSelect',
    component: StampSelect,
  },
  UnitSelect: {
    path: '/user/unitSelect/:courseId/:courseName',
    name: 'UnitSelect',
    component: UnitSelect,
  },
  Study: {
    path: '/user/study/:courseId/:courseName', // query->sectionNo,unitNo
    name: 'Study',
    component: Study,
  },
};

/**
 * route設定管理クラス
 */
export default class AppRouteConfig {

  /**
   * vue-routerの設定用配列を取得します。
   *
   * @returns vue-routerの設定用配列
   */
  public static getVueRouterConfig(): RouteConfig[] {
    const getConfigs = (routes: PublicRoutesData | AuthorizedRoutesData): RouteConfig[] => {
      return _.map(
        routes,
        (route) => {
          return _.pick(route, ['path', 'component', 'name', 'redirect']) as RouteConfig;
        }
      );
    };

    const configs = getConfigs(_.merge(PublicRoutes));
    configs.push(
      {
        path: '/user/authorized',
        component: Authorized,
        children: getConfigs(AuthorizedRoutes)
      }
    );

    return configs;
  }



}
